import { DND_DROP_ID_ATTR, DND_DROPPABLE_ATTR, DND_ZONE_ATTR } from './attributes'

// Every item carries its kit id. A drag only reaches droppables of its own kit,
// and only inside the same innermost zone of that kit (or outside every zone of
// that kit when the source has none). Everything is resolved at event time
// with ancestor walks, never during render.

export type DndScope = {
    kitId: string
    /** Innermost zone of the kit around the source, or null outside every zone. */
    zone: HTMLElement | null
}

/** What every gesture kind knows: where it may drop, what it carries, and what it lifted. */
export type Gesture = {
    scope: DndScope
    payload: unknown
    sourceElement: HTMLElement
}

export function kitDroppableSelector(kitId: string): string {
    return `[${DND_DROPPABLE_ATTR}="${kitId}"]`
}

// Same match as closest(`[attr="value"]`): nearest self-or-ancestor whose
// attribute exactly equals the value, stopping at the first match. A direct
// getAttribute walk skips the selector engine's parse-and-match cost, which
// matters on per-frame hit-tests and per-candidate scope checks.
export function nearestWithAttribute(element: Element, attr: string, value: string): Element | null {
    for (let node: Element | null = element; node !== null; node = node.parentElement) {
        if (node.getAttribute(attr) === value) return node
    }
    return null
}

function zoneOf(element: Element, kitId: string): HTMLElement | null {
    const zone = nearestWithAttribute(element, DND_ZONE_ATTR, kitId)
    return zone instanceof HTMLElement ? zone : null
}

export function inScope(element: Element, scope: DndScope): boolean {
    return zoneOf(element, scope.kitId) === scope.zone
}

export function readDropId(element: Element): string | undefined {
    return element.getAttribute(DND_DROP_ID_ATTR) ?? undefined
}

export function toGesture(kitId: string, payload: unknown, sourceElement: HTMLElement): Gesture {
    return { scope: { kitId, zone: zoneOf(sourceElement, kitId) }, payload, sourceElement }
}
